import type { BoxGeometry } from '../../helpers/boxGeometry';

import styles from './Box.module.scss';

export interface BoxProps {
    geometry: BoxGeometry;
    toolTip?: string;
    showTag?: boolean;
}

/**
 * One detection box.
 *
 * `data-tag` is what Box.module.scss selects on for the border colour and width, so it is
 * rendered here. It used to be assigned imperatively by the overlay's ref callback - which
 * meant a Box rendered anywhere else had no styling at all, and that the attribute silently
 * went missing whenever the callback's index-based pairing did not line up.
 *
 * The tooltip is a plain `data-tip` attribute, read by CSS via `content: attr(data-tip)`.
 * The overlay used to also push it into a `--mouseOverText` custom property and then read
 * it back out of the computed style, to hand it to a callback that ignored it.
 *
 * `data-type={instanceKey}` is gone: no stylesheet in the repo selects on it, and the
 * overlay's ref callback used to set it a second time imperatively.
 */
export default function Box(props: BoxProps) {
    const { geometry, toolTip = '', showTag = true } = props;

    return (
        <div
            className={styles.box}
            data-tag={geometry.tag}
            data-tip={toolTip}
            data-showmeta={showTag}
            style={{
                top: `${geometry.top}%`,
                left: `${geometry.left}%`,
                width: `${geometry.width}%`,
                height: `${geometry.height}%`,
            }}
        />
    );
}
